<script setup>
import { defineProps } from 'vue';
defineProps({
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['xs','sm', 'md', 'lg'].includes(value)
  },
  text: {
    type: String,
    default: 'Loading...'
  },
  showText: {
    type: Boolean,
    default: true
  }
});
</script>

<template>
  <div class="loading-spinner">
    <svg 
      :class="[
        'animate-spin',
        size === 'xs' ? 'h-3 w-3' : size === 'sm' ? 'h-4 w-4' : size === 'md' ? 'h-5 w-5' : 'h-6 w-6'
      ]" 
      xmlns="http://www.w3.org/2000/svg" 
      fill="none" 
      viewBox="0 0 24 24"
    >
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
    <span v-if="showText" :class="[
      'ml-2',
      size === 'xs' ? 'text-xs' : size === 'sm' ? 'text-sm' : size === 'md' ? 'text-base' : 'text-lg'
    ]">{{ text }}</span>
  </div>
</template>

<style scoped lang="postcss">
.loading-spinner {
  @apply flex items-center justify-center text-current;
}
</style> 